module.exports = __webpack_public_path__ + "img/youtube-brands-1.ecd198c9.svg";